var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.classP,attrs:{"disabled":_vm.disabled,"loading":_vm.loading}},[_c('v-card-text',{class:'card-text text-center ' +
        _vm.type +
        (_vm.active ? ' active' : '') +
        (_vm.savitarna ? ' savitarna' : '')},[_c('v-icon',{class:'bg-icon ' + _vm.type + (_vm.savitarna ? ' savitarna' : '')},[_vm._v(_vm._s(_vm.icon))]),_c('v-icon',{class:'main-icon ' +
          _vm.type +
          (_vm.active ? ' active' : '') +
          (_vm.savitarna ? ' savitarna' : '')},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }